"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOriginalAncestorsRefIds = exports.getRefCompIdFromInflatedId = exports.getUniqueId = exports.REF_DELIMITER = void 0;
exports.REF_DELIMITER = '_r_';
var getUniqueId = function (refId, originalId) { return "" + refId + exports.REF_DELIMITER + originalId; };
exports.getUniqueId = getUniqueId;
var getRefCompIdFromInflatedId = function (id) { return id.split("" + exports.REF_DELIMITER)[0]; };
exports.getRefCompIdFromInflatedId = getRefCompIdFromInflatedId;
var getOriginalAncestorsRefIds = function (id) { return id.split("" + exports.REF_DELIMITER); };
exports.getOriginalAncestorsRefIds = getOriginalAncestorsRefIds;
//# sourceMappingURL=refUtils.js.map